import json from './sprite.js';

export default {
    handle: 'SP_SPT7-Cookie',
    label: 'es_SPT7-Cookie_234684207',
    json,
};
